export const mail = {
  '站内信': '메시지',
  "返回": "돌아가기",
  '有未读信息': '{amount}개 안읽음 메시지',
  '全部标记为已读': '모든 메시지 읽음 상태로 표시',
  '隐藏已读消息': '안읽음 메시지만 표시',
  '展开': '더보기',
};


// WEBPACK FOOTER //
// ./src/i18n/lang/mail/kr.js